import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关注木瓜影视的最新剧集更新和平台动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, index) => (
            <div
              key={item.id}
              className="flex items-start gap-4 py-4 group cursor-pointer"
              style={{ animation: `fadeInUp 0.4s ease-out ${index * 0.06}s both` }}
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5"></div>
                {index < updateItems.length - 1 && (
                  <div className="w-px h-full bg-background-200 mt-1.5 group-last:hidden"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-4 border-b border-background-200/70">
                <div className="flex items-center gap-3 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
                <p className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}